import ContinuousReportView from '@/template/views/ContinuousReportView.vue';
import TargetGroupsAndOperationView from '@/template/components/continuousReport/TargetGroupsAndOperationView.vue';
import MetersAndMonitoringView from '@/template/components/continuousReport/MetersAndMonitoringView.vue';
import VolunteersAndPartnersView from '@/template/components/continuousReport/VolunteersAndPartnersView.vue';
var titleKey = function () { return 'ContinuousReport.Title'; };
var instructionLinksFactory = function (configuredLinks, languageCode, continuousReport) {
    var type = null;
    return {
        id: "continuousreport",
        type: type,
        links: {
            aidInstructions: { titleKey: "Btn_AidInstructions", linkUrl: languageCode === 'fi' ? configuredLinks.aidApplicationFi : configuredLinks.aidApplicationSv }
        }
    };
};
var targetGroupsAndOperation = function (continuousReport) {
    return {
        recordId: continuousReport.id,
        sectionModel: continuousReport.targetGroupsAndOperation,
        targetGroupOptions: continuousReport.targetGroups
    };
};
var metersAndMonitoring = function (continuousReport) {
    return {
        recordId: continuousReport.id,
        sectionModel: continuousReport.metersAndMonitoring,
        /* TODO: Pending STEA testing. The available target groups for linking may need to be quarter specific. */
        targetGroupOptions: continuousReport.targetGroups
    };
};
var collaboration = function (continuousReport) {
    return {
        recordId: continuousReport.id,
        sectionModel: continuousReport.volunteersAndPartners,
        /* TODO: Pending STEA testing. The available target groups for linking may need to be quarter specific. */
        targetGroupOptions: continuousReport.targetGroups
    };
};
export var route = {
    path: '/continuousReport/:id',
    component: ContinuousReportView,
    props: {
        titleKey: titleKey,
        recordableType: "ContinuousReport",
        instructionLinksFactory: instructionLinksFactory,
        multipleSections: true
    },
    children: [
        {
            name: 'continuousReport',
            path: '',
            component: TargetGroupsAndOperationView,
            meta: {
                title: 'ContinuousReport.Menu.TargetGroupsAndOperation',
                section: 1,
                usePeriods: true,
                useMonths: true,
                props: targetGroupsAndOperation,
                deletable: false
            }
        },
        {
            name: 'continuousReport-meters',
            path: 'meters',
            component: MetersAndMonitoringView,
            meta: {
                title: 'ContinuousReport.Menu.MetersAndMonitoring',
                section: 2,
                usePeriods: true,
                useMonths: false,
                props: metersAndMonitoring,
                deletable: false
            }
        },
        {
            name: 'continuousReport-collaboration',
            path: 'collaboration',
            component: VolunteersAndPartnersView,
            meta: {
                title: 'ContinuousReport.Menu.Collaboration',
                section: 3,
                usePeriods: true,
                useMonths: false,
                props: collaboration,
                deletable: false
            }
        }
    ]
};
